import { createContext, useContext } from 'react';

import { Citation } from './CitationText';
import { UploadedFile } from './types';

export interface PdfContextState {
  uploadedFiles: UploadedFile[];
  setUploadedFiles: (
    files: UploadedFile[] | ((prev: UploadedFile[]) => UploadedFile[]),
  ) => void;
  handlePreview: (file: UploadedFile) => Promise<void>;
  handleCitationClick: (citation: Citation) => Promise<void>;
  handleRemove: (fileId: string) => void;
  loadThreadFiles: (threadId: string) => Promise<void>;
  showPreview: boolean;
  setShowPreview: (show: boolean) => void;
  currentPreviewFile: UploadedFile | null;
  currentPage: number;
  totalPages: number;
  loading: boolean;
  error: string | null;
  textRenderer?: (textItem: { str: string; pageNumber: number }) => string;
  onDocumentLoadSuccess: ({ numPages }: { numPages: number }) => void;
  onDocumentLoadError: (error: Error) => void;
  handlePrevPage: () => void;
  handleNextPage: () => void;
}

export const PdfContext = createContext<PdfContextState | null>(null);

export const usePdfContext = (): PdfContextState => {
  const context = useContext(PdfContext);
  if (!context) {
    throw new Error('usePdfContext must be used within a PdfProvider');
  }
  return context;
};
